export const CAMPAIGN_LIMITS = {
  PAGE_TITLE_MAX_LENGTH: 50,
  PAGE_NAME_MAX_LENGTH: 50,
  TICKET_NAME_MAX_LENGTH: 20,
  TICKET_AMOUNT_MAX: 9999,
  GOAL_AMOUNT_MAX: 99_999_999,
  DESCRIPTION_MAX_LENGTH: 50,
  INVENTORY_MAX: 999_999,
  REGISTRATION_TICKET_CAPACITY_MAX: 99_999_999,
  REGISTRATION_LIMIT_MAX: 999_999,
  EVENT_PLACE_MAX_LENGTH: 100,
  EVENT_ADDRESS_MAX_LENGTH: 200,
  RECURRING_PAYMENTS_MAX: 9999,
  TICKET_FIELD_NAME_MAX_LENGTH: 30,
  TICKET_FIELD_LABEL_MAX_LENGTH: 30,
  GROUP_NAME_MAX_LENGTH: 50,
  GROUP_CREATOR_NAME_MAX_LENGTH: 50
} as const;
export const DONATION_RECURRING_TOTAL_MAX = CAMPAIGN_LIMITS.TICKET_AMOUNT_MAX * CAMPAIGN_LIMITS.RECURRING_PAYMENTS_MAX;
const installmentCountForRule = (isRecurring: boolean, recurringNumberOfPayments?: number | null): number => {
  if (!isRecurring) return 1;
  const raw = Number(recurringNumberOfPayments);
  const n = Number.isFinite(raw) && raw >= 1 ? Math.floor(raw) : 1;
  return Math.min(n, CAMPAIGN_LIMITS.RECURRING_PAYMENTS_MAX);
};
export const getMaxDonationTotalForPayments = (
  isRecurring: boolean,
  recurringNumberOfPayments?: number | null
): number =>
  isRecurring
    ? CAMPAIGN_LIMITS.TICKET_AMOUNT_MAX * installmentCountForRule(true, recurringNumberOfPayments)
    : CAMPAIGN_LIMITS.TICKET_AMOUNT_MAX;
export const validateDonationTotalPerInstallmentRule = (
  total: number,
  isRecurring: boolean,
  recurringNumberOfPayments?: number | null
): string | null => {
  if (!Number.isFinite(total)) return null;
  const n = installmentCountForRule(isRecurring, recurringNumberOfPayments);
  const per = n > 0 ? total / n : total;
  if (per > CAMPAIGN_LIMITS.TICKET_AMOUNT_MAX) {
    const maxTotal = CAMPAIGN_LIMITS.TICKET_AMOUNT_MAX * n;
    if (!isRecurring || n <= 1) {
      return `סכום חד-פעמי מוגבל ל-${CAMPAIGN_LIMITS.TICKET_AMOUNT_MAX.toLocaleString('he-IL')} ₪`;
    }
    return `כל תשלום מוגבל ל-${CAMPAIGN_LIMITS.TICKET_AMOUNT_MAX.toLocaleString(
      'he-IL'
    )} ₪; ב-${n} תשלומים ניתן עד ${maxTotal.toLocaleString('he-IL')} ₪ בסך הכל`;
  }
  return null;
};
export const MAX_FREE_FORM_TICKET_FIELDS = 10;
export const FREE_FORM_TICKET_FIELD_NAMES: string[] = Array.from(
  { length: MAX_FREE_FORM_TICKET_FIELDS },
  (_, i) => `freeField${i + 1}`
);
export function isFreeFormTicketFieldName(name: string): boolean {
  return FREE_FORM_TICKET_FIELD_NAMES.includes(name);
}
